import Vue from 'vue';
//import router from './router';

import Ionic from '@ionic/vue';

import Vue2Filters from 'vue2-filters';
import VueSanitize from "vue-sanitize";
import VueCharts from 'vue-chartjs';
import VueAwesomeSwiper from "vue-awesome-swiper";
import numFormat from 'vue-filter-number-format';
import store from './store';
import { VueTyper } from 'vue-typer';
import './registerServiceWorker';

import App from './App.vue';

Vue.use(Ionic);
Vue.use(VueTyper);
Vue.use(VueCharts);
Vue.use(Vue2Filters);
Vue.use(VueAwesomeSwiper);
Vue.config.productionTip = false;
Vue.filter('numFormat', numFormat);

Vue.use(VueSanitize, {
  allowedTags: ['a', 'button', 'div', 'li'],
  allowedAttributes: {
    'a': ['href'],
    'button': ['onclick']
  }
});

new Vue({
  //router,
  store,
  render: h => h(App)
}).$mount('#bridge');